import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authExchange } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const session_id = params.get("session_id");

    (async () => {
      if (!session_id) {
        navigate("/admin/login", { replace: true });
        return;
      }
      try {
        const data = await authExchange(session_id);
        setUser(data.user);
        // clear the hash
        window.history.replaceState(null, "", window.location.pathname);
        if (data.user?.is_admin) {
          navigate("/admin", { replace: true, state: { user: data.user } });
        } else {
          navigate("/", { replace: true, state: { user: data.user } });
        }
      } catch (e) {
        navigate("/admin/login", { replace: true, state: { error: "Sign-in failed" } });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 border-2 border-wutn border-t-transparent rounded-full animate-spin" />
        <p className="text-zinc-400 font-cond uppercase tracking-widest text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
